"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.EditableDashboardInsightWidgetHeader = void 0;
var tslib_1 = require("tslib");
// (C) 2020-2022 GoodData Corporation
var react_1 = tslib_1.__importStar(require("react"));
var sdk_model_1 = require("@gooddata/sdk-model");
var presentationComponents_1 = require("../../../presentationComponents");
var model_1 = require("../../../../model");
var EditableHeadline_1 = require("../../common/EditableHeadline");
var MAX_VISUALIZATION_TITLE_LENGTH = 200;
exports.EditableDashboardInsightWidgetHeader = function (_a) {
    var widget = _a.widget, insight = _a.insight, clientHeight = _a.clientHeight;
    var dispatch = model_1.useDashboardDispatch();
    var onWidgetTitleChanged = react_1.useCallback(function (newTitle) {
        if (newTitle) {
            dispatch(model_1.changeInsightWidgetHeader(widget.ref, { title: newTitle }));
        }
        else if (insight) {
            dispatch(model_1.changeInsightWidgetHeader(widget.ref, { title: sdk_model_1.insightTitle(insight) }));
        }
    }, [dispatch, insight, widget.ref]);
    var maxLength = Math.max(widget.title.length, MAX_VISUALIZATION_TITLE_LENGTH);
    return (react_1.default.createElement(presentationComponents_1.DashboardItemHeadlineContainer, { clientHeight: clientHeight },
        react_1.default.createElement(EditableHeadline_1.EditableHeadline, { text: widget.title, originalTitle: widget.title, maxLength: maxLength, onTitleChange: onWidgetTitleChanged })));
};
//# sourceMappingURL=EditableDashboardInsightWidgetHeader.js.map